<template>
    <div class="">

        <div class="pl-4">

            <h2>Title</h2>

            <headline class=""></headline>

            <h2 class="py-4">Actions</h2>

            <div>

                <button class="cursor-pointer" v-on:click="showExport = true">
                    <span class="mr-4 text-grey"><i class="fa fa-download"></i></span>
                    Export
                </button>

            </div>

            <modal v-if="showExport === true" @close="showExport = false">
                <h3 slot="header">Export</h3>

                <exporter></exporter>

            </modal>

            <h2 class="py-4 cursor-pointer">
                Time Series
            </h2>

            <div>

                <ul v-if="data.aggregates.length > 0" class="list-reset rounded mb-8">
                    <li
                            class="p-4 hover:bg-blue-lightest"
                            v-for="item in data.aggregates"
                    >
                        {{ item.name }}
                    </li>
                </ul>

                <ul class="list-reset">

                    <li @click="hideAll" class="p-2 text-xs">
                        <i
                                class="fa fa-circle"
                        ></i>
                        <!--<i v-show="!hidden" class="fa fa-eye"></i>
                        <i v-show="hidden" class="fa fa-eye text-grey-light" aria-hidden="true"></i>-->
                    </li>

                    <li class="hover:bg-blue-lighter"
                        v-for="(item, index) in data.data"
                    >
                        <time-series :item="item" :index="index"></time-series>
                    </li>
                </ul>
            </div>


        </div>

    </div>

</template>

<script>
    import Data from "../Data";

    export default {
        data: function () {
            return {
                data: Data,
                selected: [],
                showExport: false,
                hidden: false,
            };
        },

        computed: {
            anySelected: function () {
                return this.selected.length > 0
            },
            allSelected: function () {
                if (this.data.data === undefined) {
                    return false;
                }

                return this.selected.length >= this.data.data.length;
            }
        },

        methods: {
            hideAll() {
                const that = this;
                this.hidden = !this.hidden;
                let fags = this.data.data.filter(function (item) {
                    return item.visible === that.hidden;
                }).map(function (item) {
                    return item.id;
                });

                this.data.update('hide', fags);
            },
            isSelected(index) {
                return this.selected.indexOf(index) !== -1;
            },
            toggleSelect(index) {
                const indexOf = this.selected.indexOf(index);
                if (indexOf === -1) {
                    this.selected.push(index);
                } else {
                    this.selected.splice(indexOf, 1);
                }

            },
            toggleSelectAll() {
                if (this.allSelected) {
                    this.selected = [];
                } else {
                    this.selected = this.data.data.map(function (item, index) {
                        return index;
                    });
                }
            },
        }
    }
</script>
